import { Component } from 'vue-property-decorator';
import Base from '../Base';
import { Tabs } from 'streamlabs-beaker';
import AccountSettings from '@/components/account/AccountSettings.vue';
import PlatformSettings from '@/components/account/PlatformSettings.vue';
import SetupSLIDBanner from '@/components/topnav/SetupSLIDBanner.vue';
import { UltraCheckoutBanner } from '@streamlabs-core/sl-one-fe-components-vue2';
import { EAnalyticsEvent } from '@/helpers/analytic';
import { subscribeToUltra } from '@/helpers/streamlabs-ultra';
import TopNav from '@/components/topnav/TopNav.vue';
import MessageBanner from '@/components/topnav/MessageBanner.vue';
import { ITab } from '@/helpers/utils';
import { startCase } from 'lodash';

enum ESettingsTabs {
  streamDestinations = 'stream-destinations',
  general = 'general',
};

@Component({
  components: {
    AccountSettings,
    SetupSLIDBanner,
    PlatformSettings,
    UltraCheckoutBanner,
    TopNav,
    MessageBanner,
    STabs: Tabs,
  },
})
export default class Settings extends Base {
  selectedTab: 'stream-destinations' | 'general' = ESettingsTabs.streamDestinations;
  tabs: ITab[] = [
    {
      name: startCase(ESettingsTabs.streamDestinations),
      value: ESettingsTabs.streamDestinations,
    },
    {
      name: startCase(ESettingsTabs.general),
      value: ESettingsTabs.general,
    },
  ];

  created() {
    if (this.$route.hash.includes('general')) {
      this.selectedTab = ESettingsTabs.general;
    }

    if (this.$route.hash.includes('stream-destinations')) {
      this.selectedTab = ESettingsTabs.streamDestinations;
    }
  }

  get ESettingsTabs() {
    return ESettingsTabs;
  }

  async onBuyNow() {
    try {
      this.$sla.sendEvent(EAnalyticsEvent.ultraBannerClicked);

      await subscribeToUltra(!this.userSubscription);
    } finally {
      // forcefully reload the user to make sure we have the FE updated.
      // Currently there's no callback for user connecting on Ultra checkout page
      // Only window close event
      await this.loadUser(true);
    }
  }
}
